var EHDI = EHDI || Object.create(null);

EHDI.GetAnimationFactory = function () {
  if (EHDI._animationFactory == undefined) {
    EHDI._animationFactory = new EHDI.AnimationFactory();
  }

  return EHDI._animationFactory;
}

EHDI.AnimationFactory = function () {
  this._factory = new dragonBones.PixiFactory();
  this._animationPaths = [];
}

EHDI.AnimationFactory.prototype.addAnimation = function (animationPath) {
    if (this._animationPaths.indexOf(animationPath) == -1) {
      var textureData = EHDI.Assets.fetch(animationPath + "_tex");

      var skeletonData = EHDI.Assets.fetch(animationPath + "_ske");

      var textureImage = EHDI.Assets.images[animationPath + "_tex"].baseTexture.source;

      this._factory.addTextureAtlas(new dragonBones.TextureAtlas
      (textureImage, textureData));
      this._factory.addDragonBonesData
      (dragonBones.DataParser.parseDragonBonesData(skeletonData));
      
      this._animationPaths.push(animationPath);
    }
}

EHDI.AnimationFactory.prototype.getFactory = function () {
  return this._factory;
}
